import {
  createRouting,
  defineRoute,
  nestRoute,
} from "@/modules/router/utils/createRouting/createRouting";

export const authenticatedRouting = createRouting({
  tasks: defineRoute({
    path: "/" as const,
  }),
  taskDetails: defineRoute({
    path: "/tasks/:id" as const,
  }),
  doneSubtaskDetails: defineRoute({
    path: "/done-subtask/:id" as const,
  }),
  undoneSubtaskDetails: defineRoute({
    path: "/subtask/:id" as const,
  }),
  testPassed: defineRoute({
    path: "/test-passed" as const,
  }),
  testFailed: defineRoute({
    path: "/test-failed" as const,
  }),
  tutorials: defineRoute({
    path: "/tutorials" as const,
  }),
  tutorialDetails: defineRoute({
    path: "/tutorial-details/:id/step/:step" as const,
  }),
  tutorialTest: defineRoute({
    path: "/tutorial-test/:id" as const,
  }),
  levels: defineRoute({
    path: "/levels" as const,
    isExact: false,
  }),
  levelCongratulations: defineRoute({
    path: "/level-congratulations" as const,
  }),
  handbooks: defineRoute({
    path: "/handbooks" as const,
  }),
  dashboard: defineRoute({
    path: "/dashboard" as const,
  }),
  dashboardTaskDetails: defineRoute({
    path: "/dashboard/:id" as const,
  }),
  more: defineRoute({
    path: "/more" as const,
  }),
  signOut: defineRoute({
    path: "/sign-out" as const,
  }),
  changePassword: defineRoute({
    path: "/change-password" as const,
  }),
});

export const levelsNestedRoutes = createRouting({
  levels: nestRoute(authenticatedRouting.config.levels, {
    path: "/" as const,
  }),
  ranking: nestRoute(authenticatedRouting.config.levels, {
    path: "/ranking" as const,
  }),
});

export type Routes = keyof typeof authenticatedRouting["config"];
